
import { Component, Vue, Watch } from 'vue-property-decorator';
import UserMenu from './UserMenu.vue';
import { isDescendant } from 'ah-common-lib/src/helpers/dom';
import { BModal } from 'bootstrap-vue';
import { IndividualFileCategories } from 'ah-api-gateways';
import AsyncImage from '@/app/components/common/AsyncImage.vue';
import UserIcon from './UserIcon.vue';
import { useAuthStore } from '@/app/store/authModule';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';

@Component({
  components: {
    UserMenu,
    AsyncImage,
    UserIcon,
  },
})
export default class UserIconMenu extends Vue {
  $refs!: {
    userMenu: UserMenu;
    deleteModal: BModal;
  };
  private show = false;

  private clickListener!: (event: MouseEvent) => void;

  created() {
    if (this.authStore.isClientUser) {
      this.individualSettingsStore.loadIndividualDocuments();
    }
  }

  mounted() {
    this.clickListener = (event: MouseEvent) => {
      if (
        this.show &&
        this.$refs.userMenu &&
        event.target &&
        !isDescendant((this.$refs.userMenu as Vue).$el, event.target as Element)
      ) {
        this.show = false;
      }
    };
    window.addEventListener('click', this.clickListener);
  }

  get authStore() {
    return useAuthStore();
  }

  get individualSettingsStore() {
    return useIndividualSettingsStore();
  }

  get photo() {
    return this.individualSettingsStore.getIndividualDocument(IndividualFileCategories.PROFILE_PICTURE);
  }

  logout() {
    this.$refs.deleteModal.show();
    this.$refs.deleteModal.$once('ok', () => this.authStore.logout());
  }

  @Watch('$route')
  onRouteChange() {
    this.show = false;
  }

  beforeDestroy() {
    window.removeEventListener('click', this.clickListener);
  }

  get initials() {
    return ((this.user!.firstName || ' ')[0] + (this.user!.lastName || ' ')[0]).toUpperCase();
  }

  get user() {
    return this.authStore.loggedInIdentity;
  }
}
